import React from "react";
import MSkeleton from "@/components/ui/atoms/MSkeleton";
import styles from "../PillboxLanding.module.css";

/**
 * Placeholder shown in place of the schedule-view content (month/tabs row,
 * week strip, daytime slots, period sections) while the pillbox ledger is
 * still loading — the header card, quick actions, and pending banner above
 * it render immediately since they don't depend on the ledger fetch.
 */
const PillboxLandingSkeleton: React.FC = () => {
  return (
    <div className={styles.scheduleHeaderCluster}>
      <div className={styles.sectionHeaderRow}>
        <MSkeleton className="h-5 w-28 rounded-full" />
        <MSkeleton className="h-[33px] w-[177px] rounded-lg" />
      </div>

      <div className="flex w-full items-center gap-2">
        {Array.from({ length: 7 }, (_, i) => (
          <MSkeleton key={i} className="h-16 flex-1 rounded-xl" />
        ))}
      </div>

      <div className="flex w-full items-stretch gap-2">
        {Array.from({ length: 4 }, (_, i) => (
          <MSkeleton key={i} className="h-[83px] flex-1 rounded-2xl" />
        ))}
      </div>

      <div className={styles.periodSections}>
        {[0, 1].map((section) => (
          <div key={section} className="flex flex-col gap-3">
            <MSkeleton className="h-4 w-20 rounded-full" />
            {[0, 1].map((row) => (
              <div
                key={row}
                className="flex w-full items-center gap-3 rounded-[20px] border border-[var(--colour-border-divider-n40,#e2e2e2)] p-4"
              >
                <MSkeleton className="h-10 w-10 shrink-0 rounded-lg" />
                <div className="flex flex-1 flex-col gap-2">
                  <MSkeleton className="h-4 w-2/3 rounded-full" />
                  <MSkeleton className="h-3 w-1/3 rounded-full" />
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default PillboxLandingSkeleton;
